import { doubleMSocketService, exchangeSocketService } from '../socket/ExchangeSocketService'
import { useBaseInfoStore } from './use-base-info'

export const useWebSocketStore = defineStore('webSocketStore', () => {
  const baseInfoStore = useBaseInfoStore()

  watch(
    () => baseInfoStore.webInitInfo?.ws3Url,
    (newVal) => {
      if (newVal) {
        exchangeSocketService.dispose()
        exchangeSocketService.createSocket(newVal)
      }
    },
    {
      immediate: true,
    },
  )

  watch(
    () => baseInfoStore.webInitInfo?.mxWsv3Url,
    (newVal) => {
      if (newVal) {
        doubleMSocketService.dispose()
        doubleMSocketService.createSocket(newVal)
      }
    },
    {
      immediate: true,
    },
  )

  return {
    exchangeSocketService,
    doubleMSocketService,
  }
})
